export default __webpack_public_path__ + "static/media/img--kitchen-1-dark.a39750c5.jpg";